import request from '@/utils/request'


// 查询抽奖活动列表
export function listLotteryActivity(query) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询抽奖活动分页
export function pageLotteryActivity(query) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询抽奖活动详细
export function getLotteryActivity(data) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增抽奖活动
export function addLotteryActivity(data) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/add',
    method: 'post',
    data: data
  })
}

// 修改抽奖活动
export function updateLotteryActivity(data) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除抽奖活动
export function delLotteryActivity(data) {
  return request({
    url: '/biz/admin/lottery/lottery/activity/delete',
    method: 'post',
    data: data
  })
}
